<template>
  <LibPage />
</template>

<script>
import LibPage from '@/components/pages/LibPage.vue';

export default {
  name: 'LibView',
  components: {
    LibPage,
  },
};
</script>
